import React, { Component, Fragment } from "react";
import AppContext from "../../../contexts/AppContext";
import Posts from "../../blog/Posts";
import { Link,  NavLink } from "react-router-dom";

class DashboardLeftPanel extends Component {
    state = {
        meta: this.context.state.user,
        profileStatistic: {}
    };
    render() {
        const user = this.state.meta;
        return (
            <Fragment>
                <div>
                    {/* <div className="card text-center">
                        <div className="align-items-center">
                            <div className="col cover-photo">
                                <img src={user.background} alt="cover-photo" />
                            </div>
                            <div className="col pt-4 mt-4">
                                <div className={user.verification === "Verified" ? "avatar avatar-xl user verified" : "avatar avatar-xl user"}>
                                    <a
                                        href={user.fullurl}
                                        target="_blank"
                                    >
                                        <img
                                            src={user.image}
                                            alt={`${user.first_name} ${user.last_name}`}
                                            className="avatar-img rounded-circle"
                                        /></a>
                                </div>
                            </div>
                            <div className="col mt-2">
                                <h4 className="avtar-name mb-2">
                                    <a
                                        href={user.fullurl}
                                        target="_blank"
                                    >{`${user.first_name} ${user.last_name}`}</a>
                                </h4>
                                <p className="avtar-status">{user.membership} | {user.verification}</p>
                            </div>
                        </div>
                        <div className="col-auto"></div>

                        <div className="card-body">
                            <hr className="mb-3 mt-2" />

                            <div className="d-flex justify-content-between">
                                <p className="card-text mb-0">
                                    Applied Jobs
                                </p>
                                <p className="text-muted mb-0">
                                    <Link
                                        to={`/account/jobs/applications`}
                                    >
                                        {
                                            this.state
                                                .profileStatistic
                                                .applied_jobs_count
                                        }
                                    </Link>
                                </p>
                            </div>
                            <hr className="mb-3 mt-3" />

                            <div className="d-flex justify-content-between">
                                <p className="card-text mb-0">
                                    Open Jobs
                                </p>
                                <p className="text-muted mb-0">
                                    <Link to={`/account/jobs`}>
                                        {
                                            this.state
                                                .profileStatistic
                                                .open_Jobs
                                        }
                                    </Link>
                                </p>
                            </div>
                            <hr className="mb-3 mt-3" />

                            <div className="d-flex justify-content-between">
                                                <p className="card-text mb-0">
                                                    Portfolio Visitors
                                                </p>
                                                <p className="text-muted mb-0">
                                                    <Link to={`/account/portfolio/visitors`}>
                                                        {
                                                            this.state
                                                                .profileStatistic
                                                                .portfolio_visitors
                                                        }
                                                    </Link>
                                                </p>
                                            </div>
                        </div>
                    </div> */}
                    <div className="d-md-block d-none">
                        <Posts></Posts>
                    </div>
                </div>
            </Fragment>
            );
    }
}
DashboardLeftPanel.contextType = AppContext;
export default DashboardLeftPanel;


// WEBPACK FOOTER //
// ./src/components/employer/account/DashboardLeftPanel.js